import { IAppointmentScheduleResponse, IPatientDetail } from "@curefit/care-common";
import * as _ from "lodash";
import * as moment from "moment";
import * as React from "react";
import AppUtils from "./../../utils/AppUtils";

export interface PatientAppointmentCardProps {
    appointment: IAppointmentScheduleResponse;
    // openChat: (appointmentId: number, channelSid: string, patientName: string, context: IAppointmentActionsWithContext) => void;
    openChat: (channelSid: string, patient: IPatientDetail, identity: string) => void;
    unreadCount: number;
    isActive?: boolean;
}

const PatientAppointmentCard = (props: PatientAppointmentCardProps) => {
    let appointment = props.appointment;
    let imageCard = null;
    if (appointment.patient.displayImage !== null) {
        imageCard = <img src={appointment.patient.displayImage}/>;
    } else {
        imageCard = <div className="name-initial">{appointment.patient.name[0].toUpperCase()}</div>
    }
    let timeToDisplay = AppUtils.getRelativeDay(appointment.startTime, "D MMM Y") + " at " + moment(appointment.startTime).format("h:mm a");
    const hasChatContext = !_.isEmpty(appointment.appointmentActionsWithContext) && !_.isEmpty(appointment.appointmentActionsWithContext.chatActionWithContext) && !_.isEmpty(appointment.appointmentActionsWithContext.chatActionWithContext.context)
    const hasTwilioCommMode: any = hasChatContext && !_.isEmpty(appointment.appointmentActionsWithContext.chatActionWithContext.context.twilioCommunicationMode)
    const hasChatExpired = hasChatContext && !appointment.appointmentActionsWithContext.chatActionWithContext.action.actionPermitted

    let chatButtonCssClasses = !_.isNull(props.unreadCount) && !hasChatExpired
        ? "chat-button unread"
        : hasChatExpired
            ? "chat-button disabled"
            : "chat-button";
    let textToDisplayOnChatButton = !hasChatExpired
        ? hasTwilioCommMode
            ? AppUtils.getRelativeDay(appointment.appointmentActionsWithContext.chatActionWithContext.context.twilioCommunicationMode.updatedAt, "h:mm a", true)
            : ""
        : "Chat Expired";
    let unreadMessageCount = !_.isNull(props.unreadCount) ? props.unreadCount.toString() : "";
    let channelSid = hasTwilioCommMode ? appointment.appointmentActionsWithContext.chatActionWithContext.context.twilioCommunicationMode.modeSid : ""
    const memberIdentity: string = hasTwilioCommMode && !_.isEmpty(appointment.appointmentActionsWithContext.chatActionWithContext.context.twilioCommunicationMode.doctorTwilioUser)
        ? appointment.appointmentActionsWithContext.chatActionWithContext.context.twilioCommunicationMode.doctorTwilioUser.identity
        : ""
    return (
        <div className={`consultation-row ${props.isActive ? "active" : ""}`} key={appointment.id}>
            <div className="patient-details">
                {imageCard}
                <label className="patient-name brandon-bold">{appointment.patient.name}</label>
            </div>
            <div className="time">{timeToDisplay}</div>
            <div className="chat brandon-bold">
                <div className={chatButtonCssClasses} onClick={(event: any) => {
                    event.preventDefault();
                    !hasChatExpired && props.openChat(channelSid, appointment.patient , memberIdentity);
                }}>
                        <span className={`glyphicon glyphicon-comment ${hasChatExpired ? "disabled" : ""}`}>
                            <span className="count">
                                {unreadMessageCount}
                            </span>
                        </span>
                    <span className="chat-time">
                        {textToDisplayOnChatButton}
                        </span>
                </div>
            </div>
        </div>
    )
}

export default PatientAppointmentCard;